module.exports = __webpack_public_path__ + "img/help.e59d6ad6.svg";